import { useFormikSubmit } from "@certn/api";
import {
  ButtonGroup,
  DateFieldFormikField,
  Grid,
  GridItem,
  PrimaryButton,
} from "@certn/cascadia-react";
import { formatDate, parseDate } from "@certn/utils";
import { getLocalTimeZone, today } from "@internationalized/date";
import { isBefore } from "date-fns";
import { Form, Formik } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { object, string } from "yup";

import { useProfile } from "../../../auth/ProfileProvider";
import { SettingsEditItem } from "../../../components/settings-edit/SettingsEditItem";

export function BirthdaySettings() {
  const { t } = useTranslation();
  const { profile, refresh } = useProfile();
  const [expanded, setExpanded] = useState(false);
  const toggle = () => setExpanded((curr) => !curr);

  const { submit } = useFormikSubmit(
    "/api/internal/applicant/me/personal-info/date-of-birth/update/",
    {
      onSuccess: () => {
        toggle();
        refresh();
      },
      showToastOnError: true,
    }
  );

  return (
    <SettingsEditItem
      setting={t("Birthday")}
      value={formatDate(profile.date_of_birth, "PPP")}
      description={t(
        "We recommend using the information on a government issued identity document or birth certificate as this may be used to auto-populate forms."
      )}
      expanded={expanded}
      toggle={toggle}
      testID={expanded ? "birthday-cancel-link" : "birthday-edit-link"}
    >
      <Formik
        initialValues={{ date_of_birth: profile.date_of_birth }}
        onSubmit={submit}
        validationSchema={object({
          date_of_birth: string()
            .required()
            .label(t("Date of birth"))
            .test(
              "is-in-the-past",
              t("Date of birth must be in the past"),
              (value) => {
                const date = parseDate(value);

                return !date || isBefore(date, new Date());
              }
            ),
        })}
      >
        {({ submitForm }) => {
          return (
            <Form>
              <Grid width="416px" form>
                <GridItem>
                  <DateFieldFormikField
                    name="date_of_birth"
                    label={t("Date of birth")}
                    isRequired
                    testID="birthday-date-field"
                    maxValue={today(getLocalTimeZone())}
                    minValue={today(getLocalTimeZone()).subtract({
                      years: 120,
                    })}
                  />
                </GridItem>
                <GridItem>
                  <ButtonGroup>
                    <PrimaryButton
                      onPress={submitForm}
                      size="medium"
                      testID="birthday-save-button"
                    >
                      {t("Save")}
                    </PrimaryButton>
                  </ButtonGroup>
                </GridItem>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </SettingsEditItem>
  );
}
